const Portal = {
    LOCQ: 'locq',
    FLEET: 'fleet',
    OILCO: 'oilco',
    STATION: 'station',
    PRICETRACQ: 'pricetracq'
}
  
export default Portal;